import { createReducerContext } from 'react-use';

export const componentAction = {
    setSelectedComponent: 'SET_SELECTED_COMPONENT',
};

const componentContextReducer = (state, payload) => {
    const { action, value } = payload;

    switch (action) {
        case componentAction.setSelectedComponent:
            return {
                ...state,
                selectedComponent: value,
            };
        default:
            return { ...state };
    }
};

export const [useComponentContext, ComponentContext] = createReducerContext(componentContextReducer, {
    selectedComponent: [],
});
